<template>
  <vs-popup
    class="holamundo speaker-adv-settings"
    title="Advanced Settings"
    :active.sync="popupActive2"
  >
    <div class="single-row">
      <label for>Display speakers in Attendee list</label>
      <vs-switch v-model="settingsData.ShowInAttendee" />
    </div>
    <br />
    <div class="single-row">
      <label for>Display Filter Option</label>
      <vs-switch v-model="settingsData.ShowFilter" />
    </div>
    <br />
    <div class="single-row">
      <label for>Display Meeting Button</label>
      <vs-switch v-model="settingsData.ShowMeetingButton" />
    </div>
    <br />
    <div class="single-row">
      <label for>Display Search Option</label>
      <vs-switch v-model="settingsData.ShowSearch" />
    </div>
    <br />
    <div class="single-row">
      <label for>Display Send Message Button</label>
      <vs-switch v-model="settingsData.ShowSendMessageButton" />
    </div>
    <br />
    <div class="single-row">
      <label for>Show Email and Phone </label>
      <vs-switch v-model="settingsData.ShowEmailandPhone" />
    </div>
    <br />

    <vs-button color="rgb(76, 139, 246)" type="filled" class="sub-btn" v-on:click="saveSettings"
      >Save</vs-button
    >
  </vs-popup>
</template>
<script>
import moduleSpeakerManagement from "@/store/speaker-management/moduleSpeakerManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";

export default {
  components: {},
  props: {
    data: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      settingsData: { ShowInAttendee: false },
      popupActive2: this.data,
    };
  },
  watch: {},
  computed: {},
  methods: {
    getDefaultSettings() {
      this.IsDefaultSettings = true;
      this.settingsData = {
        ShowInAttendee: true,
        ShowSendMessageButton: true,
        ShowEmailandPhone: false,
        ShowFilter: false,
        ShowMeetingButton: false,
        ShowSearch: false,
      };
      this.popupActive2 = true;
      this.$vs.loading.close();
    },
    getSettings() {
      this.$vs.loading();
      this.IsDefaultSettings = false;
      this.$store.dispatch("speakerManagement/getSettings").then((res) => {
        this.settingsData = res;
        this.popupActive2 = true;
        this.$vs.loading.close();
      });
    },
    saveSettings() {
      this.$vs.loading();
      this.$store
        .dispatch("speakerManagement/saveSettings", {
          settingsData: this.settingsData,
          IsDefaultSettings: this.IsDefaultSettings,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message,
          });
          this.$store.dispatch("speakerManagement/allSpeakersHILAttendee", this.settingsData.ShowInAttendee);
          this.IsDefaultSettings = false;
          this.popupActive2 = false;
          this.$emit('saveSpeakerSettingsData')
          this.$vs.loading.close();
        });
    },
  },
  mounted() {},
  created() {
    if (!moduleSpeakerManagement.isRegistered) {
      this.$store.registerModule("speakerManagement", moduleSpeakerManagement);
      moduleSpeakerManagement.isRegistered = true;
    }
    this.$store.dispatch("speakerManagement/getSettings").then((res) => {
      this.settingsData = res;
      if(this.settingsData.ShowFilter == null){
        this.getDefaultSettings();
      }
    });
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule("attendeeManagement", moduleAttendeeManagement);
      moduleAttendeeManagement.isRegistered = true;
    }
  },
};
</script>
